<script setup lang="ts">
import { computed, ref, toRefs } from "vue";
import ArrowDown from "@/components/shared/icons/ArrowDown.vue";
import ArrowRight from "@/components/shared/icons/ArrowRight.vue";
import type { DataVal } from "./types.ts";

interface Props {
  node: DataVal;
  legacy?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  legacy: false,
});

const { node, legacy } = toRefs(props);

const isOpen = ref(false);
const isFolder = computed<boolean>(() => !!node.value?.children?.length);

const toggle = () => {
  isOpen.value = !isOpen.value;
};
</script>

<template>
  <li>
    <div
      v-if="node?.name"
      :class="{ 'semi-bold p-1': isFolder, group: isFolder && !legacy }"
      class="flex flex-row items-center"
      @click="toggle"
    >
      <div class="flex items-center">
        <div
          v-if="isFolder"
          class="flex items-center cursor-pointer"
          :class="{ 'group-hover:text-teal-900': !legacy }"
        >
          <div v-if="isOpen" class="flex items-center">
            <ArrowDown class="w-2.5 h-2.5" stroke="currentColor" />
          </div>
          <ArrowRight v-else custom-class="w-3 h-3" />
        </div>
      </div>
      <div class="flex flex-row flex-1 pl-2 text-13p">
        <div
          :class="{ 'flex-1 cursor-pointer': isFolder, 'group-hover:text-teal-900': isFolder && !legacy }"
          class="flex break-all font-semibold pr-2"
        >
          <span class="capitalize">{{ node?.name }}</span>
          <span v-if="!isFolder">:</span>
        </div>
        <div v-if="!isFolder" class="flex flex-1 break-all">
          {{ node?.value }}
        </div>
      </div>
    </div>
    <ul v-show="isOpen || !node?.name" v-if="isFolder">
      <template v-for="(item, index) in node?.children ?? []" :key="index">
        <JsonTreeNode
          v-if="typeof item === 'object'"
          :node="item"
          :legacy="legacy"
        />
      </template>
    </ul>
  </li>
</template>

<style scoped>
ul {
  list-style-type: none;
  margin-left: 0.5rem;
  padding: 0;
}
</style>
